// extracted by mini-css-extract-plugin
module.exports = {"close":"_normal--close--3Zskg"};